import { Component, OnInit, Input } from '@angular/core';
import {
	DomSanitizer,
	SafeResourceUrl,
	SafeUrl,
} from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NewsService } from '../../shared/services/news.service';
import { LanguageService } from '../../shared/services/language.service';

import { FaqService } from '../../shared/services/faq.service';

import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '../../shared/services/account.service';
import { UtilsService } from '../../shared/services/utils.service';
import { AppService } from '../../shared/services/app.service';

declare var $: any;
import { isBrowser } from '../../shared/thirdparty/isBrowser';

@Component({
	selector: 'app-events',
	templateUrl: './events.component.html',
	styleUrls: ['./events.component.scss'],
})
export class EventsComponent implements OnInit {

	public featuredEvent = [
		{
			id: 0,
			img: 'assets/faq-en-anthony-events.jpg',
			date: this.translate.instant('Chaque jeudi'),
			hour: '14h30 - 15h30',
			language: this.translate.instant('Français / Anglais'),
			location: this.translate.instant('Campus virtuel'),
			signUpLink:
				'https://communication.immersivefactory.com/registration-play-and-learn-conference-june-2021.html',
			slides: [
				{
					src: 'assets/people/Anthony_Sapin.png',
					name: 'Anthony SAPIN',
					job: this.translate.instant(
						'Custom Success Manager chez Immersive Factory'
					),
				},
			],
		},
	];
	public langSub: any;
	public page = 0;
	public nbPosts = 0;

	public youtubeVideos = [];

	public listNews: any = [];
	public id = 7;
	public slides: any = [];
	public featuredEventId = 0;
	public limit = 12;
	public itemsPerPage = 12;

	public videoSrc: SafeResourceUrl;
	public currentLang = null;

	constructor(
		protected _sanitizer: DomSanitizer,
		public newsService: NewsService,
		protected activatedRoute: ActivatedRoute,
		public language: LanguageService,
		public translate: TranslateService,
		public accountService: AccountService,
		public utilsService: UtilsService,
		public faqService: FaqService,
		public appService: AppService
	) {
		this.langSub = this.language.langChange.subscribe((data) => {
			this.refreshActus(true);
		});
	}

	ngOnInit(): void {
		this.slides = this.featuredEvent[this.featuredEventId].slides;
		this.refreshActus();
		this.getCurrentLang();
		this.videoSrc = this._sanitizer.bypassSecurityTrustResourceUrl('');
		this.refreshYoutubePlaylist();
	}

	refreshYoutubePlaylist() {
		if (this.currentLang == 'en') {
			this.faqService
				.getYoutubePlaylist('PLG_uQlJgy_dA_W3XCQDN-fL9Cdz_fL3Mb')
				.then((results) => {
					this.youtubeVideos = results;
				});
		} else {
			this.faqService
				.getYoutubePlaylist('PLG_uQlJgy_dAGfKY8fKh0J6Qhkfb__9nU')
				.then((results) => {
					this.youtubeVideos = results;
				});
		}
	}

	ngOnDestroy() {
		this.langSub.unsubscribe();
	}

	refreshActus(reset = false) {
		return Promise.resolve()
			.then(() => {
				return this.newsService.getPostsByTag(
					this.id,
					this.page,
					this.limit
				);
			})
			.then((res) => {
				if (reset) {
					this.listNews = [];
				}
				this.nbPosts = res['nbResults'];
				if (res['results']) {
					for (let post of res['results']) {
						if (
							!this.listNews.find(
								(e) => Number(e['id']) == Number(post['id'])
							)
						) {
							this.listNews.push(post);
						}
					}
				}
			});
	}

	showMoreActu() {
		this.limit = this.limit + this.itemsPerPage;
		this.refreshActus();
	}

	getCurrentLang() {
		this.currentLang = this.translate.store.currentLang;
	}

	video(url) {
		this.videoSrc = this._sanitizer.bypassSecurityTrustResourceUrl(
			'https://www.youtube.com/embed/' +
				url +
				'?autoplay=1&amp;modestbranding=1&amp;showinfo=0'
		);

		var modal = document.querySelector('.modal');
		var container = modal.querySelector('.modal-content');

		// Check if we click outside the modal in order to stop the video
		document
			.querySelector('.modal')
			.addEventListener('click', function (e) {
				if (e.target !== container) {
					document.getElementById('video').setAttribute('src', '');
				}
			});
	}
}
